import { render, staticRenderFns } from "./DefListTooltipItem.vue?vue&type=template&id=20ff2823&scoped=true&"
import script from "./DefListTooltipItem.vue?vue&type=script&lang=js&"
export * from "./DefListTooltipItem.vue?vue&type=script&lang=js&"
import style0 from "./DefListTooltipItem.vue?vue&type=style&index=0&id=20ff2823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff2823",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ff2823')) {
      api.createRecord('20ff2823', component.options)
    } else {
      api.reload('20ff2823', component.options)
    }
    module.hot.accept("./DefListTooltipItem.vue?vue&type=template&id=20ff2823&scoped=true&", function () {
      api.rerender('20ff2823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefListTooltipItem.vue"
export default component.exports